import React from 'react';
import { motion } from 'framer-motion';
import { Award, CheckCircle2, Flag } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: Award,
    text: '30+ Years Experience'
  }, {
    icon: CheckCircle2,
    text: '10,000+ Orders Completed'
  }, {
    icon: Flag,
    text: 'Printed IN HOUSE in San Diego, CA'
  }];
  return <div className="bg-black text-white py-8 border-y-4 border-black" data-id="element-240">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-241">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center" data-id="element-242">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center justify-center gap-3" data-id="element-243">
              <stat.icon className="w-6 h-6" strokeWidth={2.5} data-id="element-244" />
              <span className="font-display font-bold uppercase tracking-wider text-lg" data-id="element-245">
                {stat.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}